import React from 'react';

import { ContentCard, ContentCardIconType } from 'ui/component';

import classNames from './EABDZeroTouchContentCard.module.scss';

export interface ZeroTouchContentCardProps {
  readonly isInFocus: boolean;
  readonly style?: React.CSSProperties;
}

export const ZeroTouchContentCard = React.memo<ZeroTouchContentCardProps>((props) => {
  const { isInFocus, style } = props;

  return (
    <ContentCard title={'Zero-touch'} iconType={ContentCardIconType.TERMINAL} isInFocus={isInFocus} style={style}>
      <p className={classNames.body}>
        {'Telecom networks that autonomously determine which actions to take with minimal human intervention.'}
      </p>
    </ContentCard>
  );
});
